import React, { useRef, useEffect } from 'react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".style_spin__5uCiL,.style_spin__5uCiL svg {animation: style_iconpark-spin__mGDV3 1s infinite linear;}\n.style_rtl__vYVyg,.style_rtl__vYVyg svg {transform: scaleX(-1);}\n.style_spin__5uCiL.style_rtl__vYVyg,.style_spin__5uCiL.style_rtl__vYVyg svg {animation: style_iconpark-spin-rtl__ZyqaE 1s infinite linear;}\n@keyframes style_iconpark-spin__mGDV3 {\n  0% { -webkit-transform: rotate(0); transform: rotate(0);} 100% {-webkit-transform: rotate(360deg); transform: rotate(360deg);}\n}\n@keyframes style_iconpark-spin-rtl__ZyqaE {\n  0% {-webkit-transform: scaleX(-1) rotate(0); transform: scaleX(-1) rotate(0);} 100% {-webkit-transform: scaleX(-1) rotate(360deg); transform: scaleX(-1) rotate(360deg);}\n}";
var styles = {"spin":"style_spin__5uCiL","iconpark-spin":"style_iconpark-spin__mGDV3","rtl":"style_rtl__vYVyg","iconpark-spin-rtl":"style_iconpark-spin-rtl__ZyqaE"};
styleInject(css_248z);

var _excluded$_ = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function TransferData(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$_);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "1.6",
    d: "m5.334 4.666-2 2 2 2m9.332 2.668 2 2-2 2M3.334 6.666h13.333M3.334 13.334h13.333",
    "data-follow-stroke": "#888D92",
    stroke: _stroke
  })));
}

var _excluded$Z = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpExport(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$Z);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".3",
    d: "M13.571 2h-3.428c-.257 0-.429.171-.429.429 0 .257.172.428.429.428h2.4L7.057 8.343a.414.414 0 0 0 0 .6.414.414 0 0 0 .6 0l5.486-5.486v2.4c0 .257.171.429.428.429.258 0 .429-.172.429-.429V2.43c0-.26-.171-.43-.43-.43Z",
    "data-follow-fill": "#606060",
    "data-follow-stroke": "#606060",
    fill: _fill,
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: ".3",
    d: "M13.571 8c-.257 0-.428.171-.428.429v3.857c0 .514-.343.857-.857.857H3.714c-.514 0-.857-.343-.857-.857V3.714c0-.514.343-.857.857-.857h3.857c.258 0 .429-.171.429-.428C8 2.17 7.829 2 7.571 2H3.714A1.72 1.72 0 0 0 2 3.714v8.572A1.72 1.72 0 0 0 3.714 14h8.572A1.72 1.72 0 0 0 14 12.286V8.429C14 8.17 13.829 8 13.571 8Z",
    "data-follow-fill": "#606060",
    "data-follow-stroke": "#606060",
    fill: _fill,
    stroke: _stroke
  })));
}

var _excluded$Y = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Decrease(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$Y);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 10 8",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "#00B3A1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.152 6.643a1 1 0 0 0 1.696 0L9.044 1.53A1 1 0 0 0 8.196 0H1.804a1 1 0 0 0-.848 1.53l3.196 5.113Z",
    fill: _fill
  })));
}

var _excluded$X = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Rightarrow(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$X);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3377c__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "currentColor",
    d: "m6.332 4 4 4-4 4",
    strokeOpacity: ".45",
    strokeWidth: "1.333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: _stroke
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3377c__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "currentColor",
    d: "M0 0h16v16H0z",
    fill: _fill
  })))));
}

var _excluded$W = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Increase(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$W);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 10 8",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.152 1.357a1 1 0 0 1 1.696 0L9.044 6.47A1 1 0 0 1 8.196 8H1.804a1 1 0 0 1-.848-1.53l3.196-5.113Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#FA664C",
    fill: _fill
  })));
}

var _excluded$V = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpCopy(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$V);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 15 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillOpacity: ".65",
    d: "M9.374 4.254H2.819a.939.939 0 0 0-.936.936v8.43c0 .515.422.935.936.935h6.555a.939.939 0 0 0 .936-.936V5.19a.94.94 0 0 0-.936-.936Zm0 9.365H2.819V5.19h6.555v8.43Z",
    "data-follow-fill": "#171A1C",
    fill: _fill
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: ".65",
    d: "M12.183 1.445H5.627a.939.939 0 0 0-.936.936v.936h.936V2.38h6.556v8.429h-.936v.936h.936a.939.939 0 0 0 .936-.936V2.38a.938.938 0 0 0-.936-.935Z",
    "data-follow-fill": "#171A1C",
    fill: _fill
  })));
}

var _excluded$U = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpOverview(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$U);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "#171A1C",
    fillOpacity: ".65",
    d: "M2 1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm1 6V3h4v4H3Zm-1 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H2Zm1 6v-4h4v4H3Zm12-5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6Zm2 1v4h4v-4h-4ZM16 1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-6Zm1 6V3h4v4h-4Zm-5-6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 1 1 0-2h9V2a1 1 0 0 1 1-1Zm1 15a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Zm3-5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    fill: _fill
  })));
}

var _excluded$T = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpHelp(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$T);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: "2",
    strokeOpacity: ".65",
    stroke: "#171A1C",
    d: "M12 22a9.97 9.97 0 0 0 7.071-2.929A9.97 9.97 0 0 0 22 12a9.969 9.969 0 0 0-2.929-7.071A9.969 9.969 0 0 0 12 2a9.969 9.969 0 0 0-7.071 2.929A9.969 9.969 0 0 0 2 12a9.969 9.969 0 0 0 2.929 7.071A9.969 9.969 0 0 0 12 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2",
    strokeOpacity: ".65",
    stroke: "#171A1C",
    d: "M12 14.312v-2a3 3 0 1 0-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "#171A1C",
    fillOpacity: ".65",
    d: "M12 18.812a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    fill: _fill
  })));
}

var _excluded$S = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Qrcode(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$S);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 30 30",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.638 17.909h-7.27c-.803 0-1.455.651-1.455 1.454v7.27c0 .803.652 1.454 1.454 1.454h7.27c.803 0 1.455-.65 1.455-1.454v-7.27c0-.803-.652-1.454-1.454-1.454Zm0 7.997a.727.727 0 0 1-.727.727H4.094a.727.727 0 0 1-.727-.727V20.09c0-.402.325-.727.727-.727h5.817c.402 0 .727.325.727.727v5.816Zm4.726-7.997h-.727c-.2 0-.365.162-.365.363v6.544c0 .2.165.363.365.363h.727c.2 0 .363-.162.363-.363v-6.544a.364.364 0 0 0-.363-.363Zm-.727-5.817h.727c.2 0 .363-.163.363-.364V2.277a.364.364 0 0 0-.363-.364h-.727c-.2 0-.365.163-.365.364v9.452c0 .2.165.363.365.363Zm-11.27 0h7.27c.803 0 1.455-.652 1.455-1.454V3.367c0-.803-.652-1.454-1.454-1.454h-7.27c-.803 0-1.455.651-1.455 1.453v7.272c0 .802.652 1.454 1.454 1.454Zm0-7.998c0-.4.325-.727.727-.727h5.817c.402 0 .727.326.727.727V9.91a.727.727 0 0 1-.727.728H4.094a.727.727 0 0 1-.727-.728V4.094Zm16.36 15.996H19c-.2 0-.363.162-.363.363v7.27c0 .202.163.364.363.364h.729c.198 0 .36-.162.36-.363v-7.27a.362.362 0 0 0-.36-.364Zm7.995-5.817H2.277c-.2 0-.364.164-.364.364v.727c0 .2.163.363.364.363h25.445a.365.365 0 0 0 .365-.363v-.727c0-.2-.163-.364-.364-.364Zm-1.09-12.36h-7.27c-.802 0-1.453.651-1.453 1.453v7.272c0 .802.651 1.454 1.454 1.454h7.269c.805 0 1.455-.652 1.455-1.454V3.367c0-.803-.65-1.454-1.455-1.454Zm0 7.997a.727.727 0 0 1-.726.728h-5.818a.727.727 0 0 1-.725-.728V4.094c0-.4.325-.727.725-.727h5.818c.4 0 .726.326.726.727V9.91ZM23.36 20.09h-.726a.362.362 0 0 0-.363.363v7.27c0 .202.162.364.363.364h.726a.364.364 0 0 0 .365-.363v-7.27a.364.364 0 0 0-.365-.364Zm3.637-2.181h-.726a.364.364 0 0 0-.365.363v9.452c0 .2.164.363.365.363h.726a.363.363 0 0 0 .363-.363v-9.452a.363.363 0 0 0-.363-.363Z",
    "data-follow-fill": "#909090",
    fill: _fill
  })));
}

var _excluded$R = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconCalendar(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$R);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.93.705h1.81v1.9h6.603v-1.9h1.81v1.9h4.802v15.384c0 1.5-1.215 2.716-2.715 2.716H.045V5.319c0-1.5 1.215-2.715 2.715-2.715h2.17v-1.9Zm8.413 3.71H6.74v1.638H4.93V4.414H2.76c-.5 0-.905.405-.905.905v3.825h16.29v-4.73h-2.992v1.64h-1.81v-1.64ZM1.855 10.953v7.94H17.24c.5 0 .905-.405.905-.904v-7.036H1.855Z"
  })));
}

var _excluded$Q = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconComment(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$Q);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fb0__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "33fb0__b",
    "data-follow-fill": "#fff",
    fill: _fill
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3.458a2.3 2.3 0 0 0-2.3 2.3v13.338h1.6V2.758a.7.7 0 0 1 .7-.7h17.337v-1.6H2.3Zm15.145 14.856a.7.7 0 0 0 .7-.7V3.658h1.6v10.956a2.3 2.3 0 0 1-2.3 2.3H5.803l-4.645 3.32-.93-1.301 5.062-3.62h12.155ZM4.861 5.759h9.916v1.46H4.861V5.76Zm7.398 4.215H4.86v1.46h7.398v-1.46Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.3.458a2.3 2.3 0 0 0-2.3 2.3v13.338h1.6V2.758a.7.7 0 0 1 .7-.7h17.337v-1.6H2.3Zm15.145 14.856a.7.7 0 0 0 .7-.7V3.658h1.6v10.956a2.3 2.3 0 0 1-2.3 2.3H5.803l-4.645 3.32-.93-1.301 5.062-3.62h12.155ZM4.861 5.759h9.916v1.46H4.861V5.76Zm7.398 4.215H4.86v1.46h7.398v-1.46Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#33fb0__b)",
    fill: "currentColor",
    d: "M0 16.096h-1v1h1v-1Zm1.6 0v1h1v-1h-1ZM19.637 2.058v1h1v-1h-1Zm0-1.6h1v-1h-1v1Zm-1.492 3.2v-1h-1v1h1Zm1.6 0h1v-1h-1v1ZM5.803 16.914v-1h-.32l-.261.186.581.814Zm-4.645 3.32-.814.582.582.813.813-.581-.581-.814Zm-.93-1.301-.582-.814-.814.582.582.813.814-.581Zm5.062-3.62v-1h-.32l-.261.187.581.814Zm9.487-9.554h1v-1h-1v1Zm-9.916 0v-1h-1v1h1Zm9.916 1.46v1h1v-1h-1Zm-9.916 0h-1v1h1v-1Zm0 2.755v-1h-1v1h1Zm7.398 0h1v-1h-1v1Zm-7.398 1.46h-1v1h1v-1Zm7.398 0v1h1v-1h-1ZM1 2.758a1.3 1.3 0 0 1 1.3-1.3v-2a3.3 3.3 0 0 0-3.3 3.3h2Zm0 13.338V2.758h-2v13.338h2Zm.6-1H0v2h1.6v-2ZM.6 2.759v13.338h2V2.758h-2Zm1.7-1.7a1.7 1.7 0 0 0-1.7 1.7h2a.3.3 0 0 1-.3.3v-2Zm17.337 0H2.3v2h17.337v-2Zm-1-.6v1.6h2v-1.6h-2Zm-16.337 1h17.337v-2H2.3v2Zm14.845 13.156a.3.3 0 0 1 .3-.3v2a1.7 1.7 0 0 0 1.7-1.7h-2Zm0-10.956v10.956h2V3.658h-2Zm2.6-1h-1.6v2h1.6v-2Zm1 11.956V3.658h-2v10.956h2Zm-3.3 3.3a3.3 3.3 0 0 0 3.3-3.3h-2a1.3 1.3 0 0 1-1.3 1.3v2Zm-11.642 0h11.642v-2H5.803v2ZM1.74 21.048l4.646-3.32L5.222 16.1.576 19.42l1.163 1.628Zm-2.325-1.534.93 1.302 1.627-1.163-.93-1.302-1.627 1.163ZM4.709 14.5l-5.063 3.62 1.163 1.627 5.063-3.618L4.709 14.5Zm12.736-.186H5.29v2h12.155v-2Zm-2.668-9.555H4.861v2h9.916v-2Zm1 2.46V5.76h-2v1.46h2Zm-10.916 1h9.916v-2H4.861v2Zm-1-2.46v1.46h2V5.76h-2Zm1 5.215h7.398v-2H4.86v2Zm1 .46v-1.46h-2v1.46h2Zm6.398-1H4.86v2h7.398v-2Zm-1-.46v1.46h2v-1.46h-2Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fb0__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .458)",
    d: "M0 0h20v20H0z",
    "data-follow-fill": "#fff",
    fill: _fill
  })))));
}

var _excluded$P = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconFunction(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$P);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fb1__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.027 5.45 10 .567.973 5.45v10.12l1.61-.947-.01-.006V6.404L10 2.386l7.422 4.015 1.605-.944V5.45ZM10 20.433l-7.382-3.974 1.613-.95L10 18.617l7.427-3.999V8.254l1.6-.941v8.26L10 20.433Zm5.613-12.275-4.858 2.753v4.937h-1.6v-4.94L4.39 8.171l.796-1.388 4.771 2.74 4.867-2.758.789 1.392Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fb1__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .5)",
    d: "M0 0h20v20H0z",
    "data-follow-fill": "#fff",
    fill: _fill
  })))));
}

var _excluded$O = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconFly(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$O);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fb2__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.732 6.532 19.42.616l.483 1.526L2.755 7.57l4.752 2.601-1.134 1.204L.57 8.198c-.703-.385-.601-1.424.162-1.666Zm12.654 11.234 4.108-13.187 1.859-.588-4.881 15.668a.91.91 0 0 1-1.636.22l-4.938-7.74 4.599-4.972 1.174 1.087-3.76 4.065 3.475 5.447Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fb2__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .458)",
    d: "M0 0h20v20H0z",
    "data-follow-fill": "#fff",
    fill: _fill
  })))));
}

var _excluded$N = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconProgram(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$N);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fb3__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.259 1.272a1.8 1.8 0 0 0-1.8 1.8v7.136H9.32V1.273H2.26Zm-.2 1.8c0-.11.09-.2.2-.2H7.72v5.736H2.06V3.072Zm17.482-1.8H10.68v11.877h8.861V1.272ZM12.28 11.549V2.872h5.661v8.677H12.28Zm-11.821 0H9.32v8.936H.46V11.55Zm1.6 1.6v5.736H7.72V13.15H2.06Zm17.482 1.325H10.68v6.011h7.061a1.8 1.8 0 0 0 1.8-1.8v-4.211Zm-7.261 4.411v-2.811h5.661v2.611a.2.2 0 0 1-.2.2H12.28Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fb3__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .879)",
    d: "M0 0h20v20H0z",
    "data-follow-fill": "#fff",
    fill: _fill
  })))));
}

var _excluded$M = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconTraffic(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$M);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.992 4.02A2.2 2.2 0 0 1 12.1 5.13l1.6.01a3.804 3.804 0 0 0-1.91-3.324l-.002-.001a3.8 3.8 0 0 0-5.187 1.411 3.805 3.805 0 0 0 .758 4.715L4.005 13.8l1.388.795 4.109-7.174-.695-.398a2.202 2.202 0 0 1-.815-3.004Zm6.226 9.4-3.692-5.956 1.36-.843 3.403 5.489a3.801 3.801 0 1 1 .9 7.493 3.784 3.784 0 0 1-2.53-.966l1.065-1.193a2.201 2.201 0 1 0 .55-3.643l-.764.348-.292-.73Zm-10.96.253a2.201 2.201 0 1 0 2.753 2.13v-.8h8.636v1.6h-7.12a3.801 3.801 0 1 1-4.668-4.479l.399 1.55Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$L = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconDeveloper(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$L);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.3 1.458a2.3 2.3 0 0 0-2.3 2.3v15.77h1.6V3.759a.7.7 0 0 1 .7-.7H18v.004h1.6V1.458H2.3ZM18 17.228V4.663h1.6V17.23a2.3 2.3 0 0 1-2.3 2.3H3.2v-1.6h14.1a.7.7 0 0 0 .7-.7Zm-7.628-10.34L7.721 14.32l1.507.537 2.651-7.434-1.507-.537Zm3.823 4.067-1.65-1.696 1.148-1.116 2.193 2.255a.81.81 0 0 1-.008 1.138l-2.24 2.236-1.13-1.132 1.688-1.685Zm-7.14-1.696-1.65 1.696 1.688 1.685-1.131 1.132-2.24-2.236a.81.81 0 0 1-.008-1.138l2.193-2.255 1.147 1.116Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$K = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconDataset(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$K);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 1.422a2.3 2.3 0 0 0-2.3 2.3v15.771h1.6V3.722a.7.7 0 0 1 .7-.7h15.7v.004h1.6V1.422H2.5Zm15.7 15.771V4.626h1.6v12.567a2.3 2.3 0 0 1-2.3 2.3H3.4v-1.6h14.1a.7.7 0 0 0 .7-.7Zm-11.028-4.92L8.643 9.21l2.148 5.506a.9.9 0 0 0 1.612.132l1.529-2.575h2.335v-1.6H13.02l-1.261 2.124-2.212-5.67a.9.9 0 0 0-1.65-.062l-1.732 3.608H3.912v1.6h3.26Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$J = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconPay(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$J);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 14 14",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    height: "14",
    width: "14",
    y: "0",
    x: "0",
    maskUnits: "userSpaceOnUse",
    id: "33fb7__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h14v14H0z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#33fb7__a)",
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5A5.5 5.5 0 0 0 1.59 8H.577a6.5 6.5 0 0 1 12.61-3h-1.06A5.502 5.502 0 0 0 7 1.5ZM1.876 11A6.5 6.5 0 0 0 13.5 7h-1a5.5 5.5 0 0 1-9.275 4H1.876Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.395 9.7a.2.2 0 0 1 .258-.197l2.193.657a.2.2 0 0 1 .064.35l-2.128 1.632a.2.2 0 0 1-.322-.153L1.395 9.7ZM13.27 5.678a.2.2 0 0 0 .257-.197l-.067-2.292a.2.2 0 0 0-.321-.153l-2.13 1.632a.2.2 0 0 0 .065.35l2.196.66ZM9.5 3.928a.128.128 0 0 0-.128-.128h-.87a.126.126 0 0 0-.114.07L7.036 6.566h-.053L5.63 3.87a.128.128 0 0 0-.113-.07h-.89a.12.12 0 0 0-.06.016.127.127 0 0 0-.051.172l1.659 3.06h-.91a.128.128 0 0 0-.128.128v.433c0 .07.057.128.128.128h1.213v.622H5.265a.128.128 0 0 0-.128.128v.433c0 .07.057.128.128.128h1.213v1.012c0 .07.058.128.128.128h.797c.07 0 .128-.057.128-.128V9.046h1.218c.07 0 .128-.057.128-.128v-.432a.128.128 0 0 0-.128-.128H7.531v-.623h1.218c.07 0 .128-.058.128-.128v-.433a.128.128 0 0 0-.128-.127h-.92l1.657-3.06a.146.146 0 0 0 .014-.06Z"
  }))));
}

var _excluded$I = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconSetting(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$I);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.027 4.95 10 .067.973 4.95v10.12l1.61-.947-.01-.006V5.904L10 1.886l7.422 4.015 1.605-.944V4.95ZM10 19.933l-7.382-3.974 1.613-.95L10 18.117l7.427-3.999V7.754l1.6-.941v8.26L10 19.933ZM8.15 10a1.85 1.85 0 1 1 3.7 0 1.85 1.85 0 0 1-3.7 0ZM10 6.55a3.45 3.45 0 1 0 0 6.9 3.45 3.45 0 0 0 0-6.9Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$H = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconClassify(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$H);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.573 2.523a2.3 2.3 0 0 1 2.3-2.3h16.5v1.6h-16.5a.7.7 0 0 0-.7.7v16.844h-1.6V2.523Zm13.772 5.052H5.776v-1.6h8.57v1.6Zm-2.18 4.33v-1.6h-6.39v1.6h6.388Zm5.662-8.483v14.392l-7.791-3.011-6.263 2.517v1.724l6.274-2.521 8.278 3.199a.81.81 0 0 0 1.102-.756V3.422h-1.6Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$G = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconTip(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$G);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.697 7.336a.3.3 0 0 1 .3.3v4.236h.89c.186 0 .336.15.336.336v1.075c0 .186-.15.336-.336.336H7.181a.336.336 0 0 1-.336-.336v-1.075c0-.185.15-.336.336-.336h.897V9.104l-.173.001a.336.336 0 0 1-.336-.336V7.676c0-.185.15-.336.336-.336l.43-.001a.302.302 0 0 1 .043-.003h1.32Zm-.176-2.944c.186 0 .336.15.336.336v1.248c0 .185-.15.336-.336.336H8.273a.336.336 0 0 1-.336-.336V4.728c0-.186.15-.336.336-.336h1.248Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#fff",
    fill: _fill
  })));
}

var _excluded$F = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconEyeOpen(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$F);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 21 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fbb__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.218 13.366c-1.187-.904-2.192-1.958-2.927-2.803a16.854 16.854 0 0 1 2.88-2.8c1.514-1.14 3.252-1.98 5.002-1.98 1.857 0 3.583.844 5.043 1.974 1.175.91 2.13 1.97 2.776 2.803-.723.845-1.711 1.9-2.908 2.804-1.47 1.11-3.183 1.938-5.045 1.938-1.697 0-3.352-.816-4.821-1.936Zm4.955-9.383c-2.306 0-4.424 1.091-6.085 2.344C2.417 7.587 1.11 9.084.404 10.07L0 10.636l.444.534c.773.929 2.06 2.392 3.683 3.628 1.612 1.228 3.65 2.304 5.912 2.304 2.402 0 4.49-1.064 6.13-2.302 1.642-1.24 2.905-2.708 3.664-3.635l.432-.529-.392-.559c-.684-.974-1.919-2.476-3.556-3.743-1.631-1.264-3.738-2.351-6.144-2.351Zm-1.087 6.475a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0Zm1.1-2.9a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fbb__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .458)",
    d: "M0 0h20.265v20H0z",
    "data-follow-fill": "#fff",
    fill: _fill
  })))));
}

var _excluded$E = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconShare(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$E);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.54 3.36a2.9 2.9 0 0 1 2.9-2.9h6.752v1.8H3.439a1.1 1.1 0 0 0-1.1 1.1v14.2h14.2a1.1 1.1 0 0 0 1.1-1.1V9.85h1.8v6.608a2.9 2.9 0 0 1-2.9 2.9h-16v-16Zm17.088-1.097h-5.15v-1.8h6.95v7.073h-1.8V2.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.073 10.69 17.901.797l1.277 1.269-9.828 9.892-1.277-1.268Z"
  })));
}

var _excluded$D = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconHome(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$D);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.811 6.789 10 1.102.74 7.844v11.97h1.6V8.657L10 3.08l6.201 4.515 1.61-.807Zm1.449 13.024H3.94v-1.6h13.72V8.658l-.003-.002 1.603-.804v11.961Zm-5.47-5.895H6.248v1.6h7.54v-1.6Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$C = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconDoc(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$C);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5.35a1.9 1.9 0 0 0-1.9 1.9v17.4h14.9a1.9 1.9 0 0 0 1.9-1.9V.35H3.5Zm-.1 1.9a.1.1 0 0 1 .1-.1h13.1v15.6a.1.1 0 0 1-.1.1H3.4V2.25ZM5.611 6.9h5V5.1h-5v1.8Zm8.5 4h-8.5V9.1h8.5v1.8Zm-8.5 4h8.5v-1.8h-8.5v1.8Z"
  })));
}

var _excluded$B = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconMarket(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$B);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.87 1.99a.753.753 0 0 0-.12.432v15.572h5.7V1.934H1.921a.247.247 0 0 0-.05.055ZM.659 1.106C.922.744 1.352.434 1.9.434h7.05v19.06H.25V2.422c0-.483.143-.95.408-1.315Zm10.275 9.759h8.7v7.05c0 .923-.746 1.65-1.65 1.65h-7.05v-8.7Zm1.5 1.5v5.7h5.55c.086 0 .15-.066.15-.15v-5.55h-5.7Zm7.317-3.231h-8.7v-8.7h7.05c.904 0 1.65.726 1.65 1.65v7.05Zm-7.2-7.2v5.7h5.7v-5.55a.147.147 0 0 0-.15-.15h-5.55Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$A = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconDown(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$A);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 8.377v-2.37l9.895 5.744L20 5.884V8.26L9.877 14.116 0 8.377Z"
  })));
}

var _excluded$z = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconHorn(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$z);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 2.655V1L5.034 5.278H2.4a1.8 1.8 0 0 0-1.8 1.8v6.864a1.8 1.8 0 0 0 1.8 1.8h2.649l.938.245v-1.061h.005V6.66L16.15 3.593l-.004-.015 3.055-.923ZM4.392 6.877H2.4a.2.2 0 0 0-.2.2v6.864c0 .11.09.2.2.2h1.992V6.878ZM19.2 19.441 7.587 16.406v-1.654L17.6 17.369V4.809l1.6-.483v15.115Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$y = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconCheck(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$y);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.567 5.05-1.414-1.414-9.92 9.92-6.386-6.384L.433 8.586l7.778 7.778.021-.021.021.02L19.567 5.05Z"
  })));
}

var _excluded$x = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconEyeClose(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$x);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m.258 7.257 1.384-1.151c1.525 1.833 4.356 4.863 8.316 4.863 3.96 0 6.8-3.032 8.296-4.858l1.392 1.14c-.664.812-1.691 1.995-3.056 3.057l2.362 2.63-1.34 1.202-2.526-2.812a11.11 11.11 0 0 1-2.064.94l1 2.963-1.706.576-1.055-3.127a9.54 9.54 0 0 1-2.622-.002l-1.056 3.129-1.705-.576 1.002-2.969a11.125 11.125 0 0 1-2.06-.941l-2.533 2.82-1.339-1.204 2.37-2.637C1.955 9.24.928 8.063.257 7.257Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}

var _excluded$w = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function IconUp(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$w);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 11.623v2.37L9.895 8.25 20 14.116V11.74L9.877 5.885 0 11.623Z"
  })));
}

var _excluded$v = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpDel(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$v);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 22 22",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.42 4.8a.8.8 0 0 1 .8-.8h2.915a.8.8 0 0 1 .8.8v.406a.6.6 0 0 1-.6.6H9.02a.6.6 0 0 1-.6-.6V4.8ZM3.043 6.025C3 6.111 3 6.223 3 6.447v.526c0 .224 0 .336.044.422a.4.4 0 0 0 .174.174c.086.044.198.044.422.044h.565a.6.6 0 0 1 .6.6V17.2a.8.8 0 0 0 .8.8h10.142a.8.8 0 0 0 .8-.8V8.213a.6.6 0 0 1 .6-.6h.568c.224 0 .336 0 .421-.044a.4.4 0 0 0 .175-.174c.044-.086.044-.198.044-.422v-.526c0-.224 0-.336-.044-.422a.4.4 0 0 0-.175-.175c-.085-.043-.197-.043-.421-.043H3.64c-.224 0-.336 0-.422.043a.4.4 0 0 0-.174.175Zm4.925 4.698c0-.22.18-.4.4-.4h1.007c.22 0 .4.18.4.4v3.716a.4.4 0 0 1-.4.4H8.369a.4.4 0 0 1-.4-.4v-3.716Zm3.615 0c0-.22.18-.4.4-.4h1.007c.22 0 .4.18.4.4v3.716a.4.4 0 0 1-.4.4h-1.007a.4.4 0 0 1-.4-.4v-3.716Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#fff",
    fill: _fill
  })));
}

var _excluded$u = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpCheck(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$u);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 21 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fcb__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M20.918 10.378c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10Zm-6.509-3.246.547.46a.714.714 0 0 1 .089 1.005l-4.473 5.327-.315.38a.714.714 0 0 1-1.006.092l-.011-.01-1.068-.924-.006-.005-1.768-1.532a.714.714 0 0 1-.072-1.007l.01-.01.479-.533a.714.714 0 0 1 .996-.063l1.74 1.497 3.852-4.59a.715.715 0 0 1 1.006-.087Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fcb__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.918 .378)",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var _excluded$t = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpClose(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$t);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 21 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fcc__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M20.888 10.378c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10ZM14.69 7.31a.572.572 0 0 1 0 .808l-2.273 2.273 2.273 2.274a.572.572 0 0 1 0 .808l-.707.707a.571.571 0 0 1-.808 0L10.9 11.906l-2.272 2.273a.572.572 0 0 1-.808 0l-.707-.707a.571.571 0 0 1 0-.808l2.271-2.273L7.113 8.12a.571.571 0 0 1 0-.808l.707-.707a.571.571 0 0 1 .808 0L10.9 8.876l2.274-2.273a.572.572 0 0 1 .808 0l.707.707Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fcc__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.888 .378)",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var _excluded$s = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpEye(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$s);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.944 4.587c4.116 0 7.78 2.444 9.453 6.173a.715.715 0 0 1 0 .514c-1.672 3.73-5.337 6.173-9.453 6.173-4.115 0-7.78-2.443-9.452-6.173a.715.715 0 0 1 0-.514C2.164 7.03 5.83 4.587 9.944 4.587Zm2.376 6.447a2.375 2.375 0 1 0-4.75 0 2.375 2.375 0 0 0 4.75 0Zm1.696 0a4.071 4.071 0 1 0-8.143 0 4.071 4.071 0 0 0 8.143 0Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$r = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpPicError(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$r);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 28 29",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.736 6.195a.82.82 0 0 1 .818.759l.003.061v7.477a5.275 5.275 0 0 0-1.641-.054V7.836H6.791v13.125h8.69c.153.594.407 1.147.743 1.64H5.971a.82.82 0 0 1-.818-.759l-.003-.061V7.015a.82.82 0 0 1 .76-.818l.06-.002h14.766Zm-2.464 6.944v1.786a5.252 5.252 0 0 0-2.946 4.394h-3.432a.245.245 0 0 1-.067-.009l-3.509-.009a.246.246 0 0 1-.173-.42l3.39-3.39a.328.328 0 0 1 .464 0l1.564 1.564 4.149-4.149a.328.328 0 0 1 .56.232Zm-7.38-3.663v2.46h-2.46v-2.46h2.46Zm9.674 14.111a3.937 3.937 0 1 0 0-7.875 3.937 3.937 0 0 0 0 7.875Zm-1.395-5.639a.44.44 0 0 1 .619 0l.773.774.773-.774a.44.44 0 0 1 .62 0l.308.31a.438.438 0 0 1 0 .619l-.773.773.773.773a.438.438 0 0 1 0 .619l-.309.31a.437.437 0 0 1-.619 0l-.773-.774-.773.773a.437.437 0 0 1-.62 0l-.309-.309a.437.437 0 0 1 0-.619l.774-.773-.774-.773a.437.437 0 0 1 0-.62l.31-.309Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#F64F4F",
    fill: _fill
  })));
}

var _excluded$q = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpExclamationCircle(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$q);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fcf__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M20 10.378c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-8.722 3.25a.556.556 0 0 0-.555-.555H9.278a.556.556 0 0 0-.555.556v1.444c0 .307.248.556.555.556h1.445a.556.556 0 0 0 .555-.556v-1.444Zm0-8.159a.556.556 0 0 0-.555-.555H9.278a.556.556 0 0 0-.555.555v5.845c0 .307.248.555.555.555h1.445a.556.556 0 0 0 .555-.555V5.469Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fcf__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .378)",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var _excluded$p = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpInfoCircle(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$p);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 21 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fd0__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M20.763 10.378c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10Zm-8.892-1.516v4.706l.99.001c.205 0 .373.167.373.374v1.194a.373.373 0 0 1-.374.374H8.742a.373.373 0 0 1-.373-.374v-1.194c0-.207.167-.374.373-.374h.996v-3.075h-.192a.373.373 0 0 1-.373-.373V8.907c0-.206.167-.373.373-.373l.475-.001a.337.337 0 0 1 .051-.004h1.466c.184 0 .333.149.333.333Zm-.155-3.231v1.387a.373.373 0 0 1-.373.373H9.956a.373.373 0 0 1-.373-.373V5.63c0-.206.167-.373.373-.373h1.387c.206 0 .373.167.373.373Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fd0__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.763 .378)",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var _excluded$o = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpPen(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$o);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.364 18.423c0-.577.468-1.045 1.045-1.045h13.273a1.046 1.046 0 0 1 0 2.09H3.409a1.045 1.045 0 0 1-1.045-1.045Zm1.09-2.772c.121 0 .24-.019.356-.056l3.826-1.217c.091 0 .182-.091.273-.182L17 5.106a.694.694 0 0 0 .182-.455.694.694 0 0 0-.182-.455l-2.818-2.818c-.273-.273-.636-.273-.91 0l-9.09 9.09c-.091.092-.091.183-.182.274l-1.273 4c-.09.272 0 .454.182.636s.364.273.546.273Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$n = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpDocsLink(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$n);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fd2__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M3.5 1.1A1.9 1.9 0 0 0 1.6 3v17.4h14.9a1.9 1.9 0 0 0 1.9-1.9V1.1H3.5ZM3.4 3a.1.1 0 0 1 .1-.1h13.1v15.6a.1.1 0 0 1-.1.1H3.4V3Zm2.211 4.65h5v-1.8h-5v1.8Zm8.5 4h-8.5v-1.8h8.5v1.8Zm-8.5 4h8.5v-1.8h-8.5v1.8Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fd2__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .75)",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var _excluded$m = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpDelete(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$m);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 10 10",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.688.867H3.302v-.8h3.386v.8ZM9.46 2.192H.538v-.8h8.923v.8ZM3.522 7.735V3.84h.8v3.895h-.8ZM5.573 3.84v3.895h.8V3.84h-.8Zm-4.116-.826h.8v5.852h-.002v1.069h-.798v-6.92Zm1.598 6.92v-.8h4.598V3.191h.8v6.744H3.055Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$l = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpClose_58g77df2(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$l);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.414 10.273 6.718 6.717-1.415 1.415L10 11.687l-6.717 6.718-1.415-1.415 6.718-6.717-6.718-6.718 1.415-1.414L10 8.86l6.718-6.718 1.414 1.414-6.718 6.718Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$k = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpDown(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$k);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.65V6.28l9.895 5.744L20 6.157v2.376L9.877 14.388 0 8.65Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$j = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpPayManage(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$j);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 14 14",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    height: "14",
    width: "14",
    y: "0",
    x: "0",
    maskUnits: "userSpaceOnUse",
    id: "33fd6__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h14v14H0z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#33fd6__a)",
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5A5.5 5.5 0 0 0 1.59 8H.577a6.5 6.5 0 0 1 12.61-3h-1.06A5.502 5.502 0 0 0 7 1.5ZM1.876 11A6.5 6.5 0 0 0 13.5 7h-1a5.5 5.5 0 0 1-9.275 4H1.876Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.395 9.7a.2.2 0 0 1 .258-.197l2.193.657a.2.2 0 0 1 .064.35l-2.128 1.632a.2.2 0 0 1-.322-.153L1.395 9.7ZM13.27 5.678a.2.2 0 0 0 .257-.197l-.067-2.292a.2.2 0 0 0-.321-.153l-2.13 1.632a.2.2 0 0 0 .065.35l2.196.66ZM9.5 3.928a.128.128 0 0 0-.128-.128h-.87a.126.126 0 0 0-.114.07L7.036 6.566h-.053L5.63 3.87a.128.128 0 0 0-.113-.07h-.89a.12.12 0 0 0-.06.016.127.127 0 0 0-.051.172l1.659 3.06h-.91a.128.128 0 0 0-.128.128v.433c0 .07.057.128.128.128h1.213v.622H5.265a.128.128 0 0 0-.128.128v.433c0 .07.057.128.128.128h1.213v1.012c0 .07.058.128.128.128h.797c.07 0 .128-.057.128-.128V9.046h1.218c.07 0 .128-.057.128-.128v-.432a.128.128 0 0 0-.128-.128H7.531v-.623h1.218c.07 0 .128-.058.128-.128v-.433a.128.128 0 0 0-.128-.127h-.92l1.657-3.06a.146.146 0 0 0 .014-.06Z"
  }))));
}

var _excluded$i = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpPlus(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$i);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-11Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#909090",
    fill: _fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#909090",
    fill: _fill
  })));
}

var _excluded$h = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpEyeOpen(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$h);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 22 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33fd8__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M6.031 12.909c-1.186-.904-2.191-1.959-2.926-2.803a16.856 16.856 0 0 1 2.88-2.8c1.513-1.14 3.252-1.98 5.002-1.98 1.857 0 3.583.843 5.042 1.973 1.176.91 2.13 1.97 2.777 2.804-.723.845-1.711 1.9-2.908 2.803-1.47 1.11-3.184 1.938-5.045 1.938-1.697 0-3.352-.816-4.822-1.935Zm4.956-9.384c-2.306 0-4.425 1.092-6.085 2.344C3.23 7.13 1.924 8.627 1.218 9.613l-.404.566.444.534c.773.928 2.06 2.392 3.683 3.628 1.612 1.228 3.65 2.303 5.912 2.303 2.402 0 4.49-1.064 6.13-2.301 1.641-1.24 2.904-2.709 3.663-3.636l.433-.528-.392-.56c-.685-.974-1.92-2.476-3.556-3.743-1.632-1.263-3.739-2.35-6.144-2.35ZM9.9 10a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0ZM11 7.1a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "33fd8__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.814)",
    fill: "#fff",
    d: "M0 0h20.265v20H0z"
  })))));
}

var _excluded$g = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpUp(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$g);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.896v2.37L9.895 8.52 20 14.388v-2.376L9.877 6.157 0 11.896Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$f = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpExport_58g77di3(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$f);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.54 3.859a2.9 2.9 0 0 1 2.9-2.9h6.752v1.8H3.439a1.1 1.1 0 0 0-1.1 1.1v14.2h14.2a1.1 1.1 0 0 0 1.1-1.1v-6.608h1.8v6.608a2.9 2.9 0 0 1-2.9 2.9h-16v-16Zm17.088-1.097h-5.15v-1.8h6.95v7.074h-1.8V2.762Z",
    "data-follow-fill": "#606060",
    fill: _fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.073 11.19 9.828-9.893 1.277 1.268-9.828 9.893-1.277-1.268Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$e = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpCalendar(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$e);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 21",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.93.41h1.81v1.899h6.603v-1.9h1.81v1.9h4.802v15.385c0 1.5-1.215 2.715-2.715 2.715H.045V5.024c0-1.5 1.215-2.715 2.715-2.715h2.17v-1.9Zm8.413 3.709H6.74v1.639H4.93v-1.64H2.76c-.5 0-.905.406-.905.906v3.824h16.29v-4.73h-2.992v1.64h-1.81v-1.64Zm-11.488 6.54v7.94H17.24c.5 0 .905-.405.905-.905v-7.036H1.855Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$d = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpEyeClose(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$d);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m.258 7.257 1.384-1.151c1.525 1.833 4.356 4.863 8.316 4.863 3.96 0 6.8-3.032 8.296-4.858l1.392 1.14c-.664.812-1.691 1.995-3.056 3.057l2.362 2.63-1.34 1.202-2.526-2.812a11.11 11.11 0 0 1-2.064.94l1 2.963-1.706.576-1.055-3.127a9.54 9.54 0 0 1-2.622-.002l-1.056 3.129-1.705-.576 1.002-2.969a11.125 11.125 0 0 1-2.06-.941l-2.533 2.82-1.339-1.204 2.37-2.637C1.955 9.24.928 8.063.257 7.257Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$c = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpUpload(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$c);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.894.36 3.08 7.005 4.198 8.15 9.2 3.271v10.407h1.6V3.38l5.165 4.785 1.087-1.173L9.894.359ZM1.8 13.42H.2v5.916h19.6V13.42h-1.6v4.316H1.8V13.42Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$b = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpCheck_58g77dgd(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$b);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.06 3.43.51.428c.283.236.26.727-.051 1.098l-5.852 6.97c-.311.37-.791.479-1.073.242l-1.02-.856 6.414-7.64c.31-.37.79-.479 1.073-.243Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#00C8D2",
    fill: _fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.426 8.3.427-.475c.232-.257.703-.213 1.062.1l4.093 3.567-.8.993c-.221.274-.699.242-1.067-.07a2.72 2.72 0 0 1-.013-.012L2.663 9.37c-.364-.319-.473-.794-.245-1.061a.468.468 0 0 1 .008-.01Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#00C8D2",
    fill: _fill
  })));
}

var _excluded$a = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function DvpItem(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$a);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 20 20",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.96.35A1.51 1.51 0 0 0 .45 1.86v7.482h8.992V.35H1.96Zm.19 7.292V2.05h5.592v5.592H2.15Zm7.292 2.916H.45v8.992h8.992v-8.992ZM2.15 17.85v-5.592h5.592v5.592H2.15ZM10.658.35h8.992v11.908h-8.992V.35Zm1.7 1.7v8.508h5.592V2.05h-5.592Zm7.292 11.425h-8.992v6.075h7.482a1.51 1.51 0 0 0 1.51-1.51v-4.565Zm-7.292 4.375v-2.675h5.592v2.675h-5.592Z",
    "data-follow-fill": "#606060",
    fill: _fill
  })));
}

var _excluded$9 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function AvaiableApp(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$9);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 12 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.667.667c.368 0 .666.3.666.666v13.334a.668.668 0 0 1-.666.666H1.333a.668.668 0 0 1-.666-.666V1.333c0-.366.298-.666.666-.666h9.334ZM10 2H2v12h8V2Zm-4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm1-7.333.039.002c.166.02.294.16.294.33v.668l-.002.038A.333.333 0 0 1 7 5H5l-.039-.002a.333.333 0 0 1-.294-.331V4l.002-.039A.333.333 0 0 1 5 3.667h2Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#939AA3",
    fill: _fill
  })));
}

var _excluded$8 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Good(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$8);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "#171A1C",
    d: "m12.245 12.879 1.176-4.162a1.61 1.61 0 0 0-1.55-2.049H9.29a.365.365 0 0 1-.355-.447l.167-.721a6.561 6.561 0 0 0 .145-2.02l-.03-.368a1.674 1.674 0 0 0-.485-1.044 1.365 1.365 0 0 0-.965-.4h-.08a.603.603 0 0 0-.527.31l-.886 1.595a4.32 4.32 0 0 1-1.708 1.695l-1.737.947c-.512.28-.83.816-.83 1.398v4.722a2 2 0 0 0 2 2h6.32a2 2 0 0 0 1.925-1.456Z",
    strokeOpacity: ".45",
    strokeWidth: "1.333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: _stroke
  })));
}

var _excluded$7 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function CommentOne(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$7);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "1.333",
    strokeOpacity: ".45",
    d: "M14.67 2H1.335v10h3v1.667L7.669 12h7V2ZM4.664 6.999h6.667",
    "data-follow-stroke": "#171A1C",
    stroke: _stroke
  })));
}

var _excluded$6 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function View(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$6);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "#171A1C",
    d: "M7.995 12c3.682 0 6.667-4 6.667-4s-2.985-4-6.667-4-6.667 4-6.667 4 2.985 4 6.667 4Z",
    strokeOpacity: ".45",
    strokeWidth: "1.333",
    strokeLinejoin: "round",
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "#171A1C",
    d: "M7.995 9.665a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Z",
    strokeOpacity: ".45",
    strokeWidth: "1.333",
    strokeLinejoin: "round",
    stroke: _stroke
  })));
}

var _excluded$5 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Camera(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$5);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.134 2.734a.733.733 0 0 0-.734.734v9.066a.733.733 0 0 0 .734.734h9.4a.735.735 0 0 0 .733-.734v-1.956l1.311.562a.733.733 0 0 0 1.022-.674v-4.93a.733.733 0 0 0-1.022-.673l-1.31.561V3.468a.733.733 0 0 0-.734-.734h-9.4Zm.466 9.334V3.934h8.467v2.35a.633.633 0 0 0 .883.582l1.45-.622v3.514l-1.45-.622a.633.633 0 0 0-.883.582v2.35H2.6Zm3.154-5.87a.871.871 0 0 1-.877.865A.871.871 0 0 1 4 6.198c0-.476.394-.864.877-.864a.87.87 0 0 1 .877.864Z",
    "data-follow-fill": "#909090",
    fill: _fill
  })));
}

var _excluded$4 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function User(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$4);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 28 28",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "#3C89FF",
    clipRule: "evenodd",
    d: "M14.003 25.665c6.443 0 11.666-5.223 11.666-11.666 0-6.444-5.223-11.667-11.666-11.667-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666Z",
    strokeWidth: "2.333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "#3C89FF",
    d: "M14.003 13.415a2.917 2.917 0 1 0 0-5.833 2.917 2.917 0 0 0 0 5.833Z",
    strokeWidth: "2.333",
    strokeLinejoin: "round",
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "#3C89FF",
    d: "M5.844 22.362a5.834 5.834 0 0 1 5.82-5.444h4.667a5.834 5.834 0 0 1 5.82 5.432",
    strokeWidth: "2.333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: _stroke
  })));
}

var _excluded$3 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function Smile(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$3);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 28 28",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: "2.333",
    d: "M13.995 25.665c6.443 0 11.667-5.223 11.667-11.666 0-6.444-5.224-11.667-11.667-11.667-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666Z",
    "data-follow-stroke": "#3C89FF",
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2.333",
    d: "M18.078 10.498v.583m-8.164-.583v.583m8.166 7.001s-1.166 2.333-4.083 2.333c-2.916 0-4.083-2.333-4.083-2.333",
    "data-follow-stroke": "#3C89FF",
    stroke: _stroke
  })));
}

var _excluded$2 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function PreviewOpen(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$2);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 48 48",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "currentColor",
    "data-follow-fill": "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "4",
    d: "M24 36c11.046 0 20-12 20-12s-8.954-12-20-12S4 24 4 24s8.954 12 20 12Z",
    fill: _fill,
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    "data-follow-fill": "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "4",
    stroke: "#fff",
    d: "M24 29a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: _fill
  })));
}

var _excluded$1 = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function GoodOne(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded$1);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 48 48",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "currentColor",
    "data-follow-fill": "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "4",
    d: "m35.911 41.544 5.37-19A2 2 0 0 0 39.356 20H27.875a1.094 1.094 0 0 1-1.066-1.34l.5-2.164c.458-1.985.605-4.03.436-6.06l-.092-1.103A5.02 5.02 0 0 0 26.2 6.2 4.096 4.096 0 0 0 23.304 5h-.24c-.657 0-1.262.356-1.58.93l-2.659 4.785a12.962 12.962 0 0 1-5.124 5.085l-6.659 3.63A2 2 0 0 0 6 21.188V41a2 2 0 0 0 2 2h25.987a2 2 0 0 0 1.924-1.456Z",
    fill: _fill,
    stroke: _stroke
  })));
}

var _excluded = ["size", "width", "height", "spin", "rtl", "color", "fill", "stroke", "className"];
function CommentOneSolid(props) {
  var root = useRef(null);

  var _props$size = props.size,
      size = _props$size === void 0 ? '1em' : _props$size,
      width = props.width,
      height = props.height,
      spin = props.spin,
      rtl = props.rtl,
      color = props.color,
      fill = props.fill,
      stroke = props.stroke,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _width = width || size;

  var _height = height || size;

  var _stroke = stroke || color;

  var _fill = fill || color;

  useEffect(function () {
    if (!_fill) {
      var _root$current;

      (_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.querySelectorAll('[data-follow-fill]').forEach(function (item) {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }

    if (!_stroke) {
      var _root$current2;

      (_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.querySelectorAll('[data-follow-stroke]').forEach(function (item) {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    ref: root,
    width: _width,
    height: _height,
    viewBox: "0 0 48 48",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className || '', " ").concat(spin ? styles.spin : '', " ").concat(rtl ? styles.rtl : '').trim()
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-follow-stroke": "currentColor",
    "data-follow-fill": "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "4",
    d: "M44 6H4v30h9v5l10-5h21V6Z",
    fill: _fill,
    stroke: _stroke
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "4",
    stroke: "#fff",
    d: "M14 21h20"
  })));
}

export { AvaiableApp, Camera, CommentOne, CommentOneSolid, Decrease, DvpCalendar, DvpCheck, DvpCheck_58g77dgd, DvpClose, DvpClose_58g77df2, DvpCopy, DvpDel, DvpDelete, DvpDocsLink, DvpDown, DvpExclamationCircle, DvpExport, DvpExport_58g77di3, DvpEye, DvpEyeClose, DvpEyeOpen, DvpHelp, DvpInfoCircle, DvpItem, DvpOverview, DvpPayManage, DvpPen, DvpPicError, DvpPlus, DvpUp, DvpUpload, Good, GoodOne, IconCalendar, IconCheck, IconClassify, IconComment, IconDataset, IconDeveloper, IconDoc, IconDown, IconEyeClose, IconEyeOpen, IconFly, IconFunction, IconHome, IconHorn, IconMarket, IconPay, IconProgram, IconSetting, IconShare, IconTip, IconTraffic, IconUp, Increase, PreviewOpen, Qrcode, Rightarrow, Smile, TransferData, User, View };
